import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const sSupabaseUrl = import.meta.env.VITE_APP_SUPABASE_URL || "";
const sSupabaseAnonKey = import.meta.env.VITE_APP_SUPABASE_ANON_KEY || "";

let oCachedClient: SupabaseClient | null = null;
let sCachedToken = "";

/**
 * Returns a Supabase client authenticated with a Clerk JWT.
 * Caches the client and only recreates when the token changes.
 */
export const fnCreateSupabaseClient = (sToken: string): SupabaseClient => {
  if (oCachedClient && sToken === sCachedToken) {
    return oCachedClient;
  }

  sCachedToken = sToken;
  oCachedClient = createClient(sSupabaseUrl, sSupabaseAnonKey, {
    global: {
      headers: {
        Authorization: `Bearer ${sToken}`,
      },
    },
    auth: {
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false,
    },
  });

  return oCachedClient;
};

/**
 * Returns true if Supabase is configured (URL + anon key present).
 */
export const fnIsSupabaseConfigured = (): boolean => {
  return Boolean(sSupabaseUrl && sSupabaseAnonKey);
};
